import { isEmpty } from 'lodash';
import React, { ReactNode } from 'react';
import { validate } from 'uuid';
import NotFound from './NotFound';

export default ({
	id,
	redirectPrefix,
	children,
}: {
	id: string;
	redirectPrefix: `/${string}`;
	children: ReactNode;
}) => {
	if (redirectPrefix.endsWith('/')) {
		console.warn("Don't include trailing slash in redirectPrefix");
	}
	if (!validate(id)) {
		const fixedId = id.slice(0, id.match(/[^a-f0-9\-]/)?.index);
		if (typeof window !== 'undefined' && fixedId !== id && !isEmpty(fixedId)) {
			location.href = `${redirectPrefix}/${fixedId}`;
			return;
		} else {
			return <NotFound />;
		}
	}
	return children;
};
